import { render, staticRenderFns } from "./safeSetting.vue?vue&type=template&id=21cc65a9&"
var script = {}


/* normalize component */
import normalizer from "!/////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports